package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A merchant promotion (`deals/{id}` — see `docs/DATA_MODEL.md`). Created by the business owner from
 * their dashboard; free while the feature bootstraps (monetizable later). A deal is LIVE when
 * [visible] (moderation kill-switch, moderator/admin-flippable) and not past [endsAtMillis].
 * [businessName] is snapshotted at creation so rails render without N business lookups.
 */
data class Deal(
    val id: String,
    val businessId: String,
    val businessName: String,
    /** Offer headline, author-provided (e.g. "20% off catering all Muharram"). */
    val title: LocalizedText,
    /** Optional fine print / how to redeem. */
    val details: LocalizedText? = null,
    val endsAtMillis: Long,
    val visible: Boolean = true,
    val createdAtMillis: Long? = null,
) {
    fun isActive(nowMillis: Long): Boolean = visible && endsAtMillis > nowMillis
}
